export function getScrollTop(window: Window, document: Document): number {
  // cross-browser scroll top https://stackoverflow.com/a/20478983
  return window.scrollY
    || document.documentElement.scrollTop
    || document.body.scrollTop
    || 0;
}
